export const EledaMessagesEN = {
  undefinedOrNull: "⍰",
  true: "true",
  false: "false",
  submitBtn: "Validate",
  nextActBtn: "Next activity",

  defaultMessageAllSolutionsFound: {
    neutral: ["Well done, you've passed the activity 🤩"],
    kids: ["Well done, you've passed the activity 🤩"],
    formal: ["Well done, you've passed the activity"],
  },
  defaultMessageAllSolutionsNotFound: {
    neutral: ["You didn't find all the answers in the activity."],
    kids: [
      "You didn't find all the answers in the activity but don't get discouraged 😉",
    ],
    formal: ["You didn't find all the answers to the activity."],
  },

  defaultMessageAllSolutionsNotFoundButRemainedAttempts: {
    neutral: [
      "You didn't find all the answers in the activity, but you can still correct your answers.",
    ],
    kids: [
      "You didn't find all the answers in the activity but you can still correct your answers 😉",
    ],
    formal: [
      "You didn't find all the answers in the activity but you can still correct your answers.",
    ],
  },

  defaultMessageAllSolutionsNotFoundButRemainedQuestions: {
    neutral: [
      "You haven't found all the answers in the activity, but there are still questions left.",
    ],
    kids: [
      "You didn't find all the answers in the activity but there are still questions 😉",
    ],
    formal: [
      "You didn't find all the answers in the activity but there are still questions.",
    ],
  },

  defaultMessageSolutionFound: {
    neutral: [
      "🟢 Congratulations, you have found the good answer",
      "🟢 Correct !",
      "🟢 Another good answer, congrats !",
      "🟢 Correct answer. Well done !",
      "🟢 That's right ! Great job !",
      "🟢 Correct answer !",
      "🟢 Right answer !",
    ],
    kids: [
      "🟢 Congratulations, you have found the good answer",
      "🟢 Waw ! Correct !",
      "🟢 Another good answer, congrats !",
      "🟢 YES ! Correct answer ! Well done !",
      "🟢 That's right ! Great job !",
      "🟢 Yes, keep going !",
      "🟢 A new maths genius is born ! Correct answer !",
      "🟢 Woop woop ! Right answer !",
    ],
    formal: [
      "🟢 Congratulations, you have found the good answer",
      "🟢 Correct !",
      "🟢 Another good answer, congrats !",
      "🟢 Correct answer. Well done !",
      "🟢 That's right.",
      "🟢 Correct answer.",
      "🟢 Right answer.",
    ],
  },

  defaultMessageSolutionFoundAtFirstAttempt: {
    neutral: "🟢 You got it right the first time, congrats !",
    kids: "🟢 Wow, you got it right the first time !!!",
    formal: "🟢 You got it right the first time, congratulations.",
  },

  defaultMessageSolutionNotFound: {
    neutral: [
      "🔴 You didn't find the solution this time...",
      "🔴 Wrong answer.",
      "🔴 It is not the correct answer...",
    ],
    kids: [
      "🔴 You didn't find the solution this time...",
      "🔴 Wrong answer, crap ! You will get it right next time !",
      "🔴 It is not the correct answer... A little more training and you will succeed !",
    ],
    formal: [
      "🔴 You didn't find the solution this time...",
      "🔴 Wrong answer.",
      "🔴 It is not the correct answer...",
    ],
  },
  defaultMessageSolutionNotFoundButRemainingAttempts: {
    neutral: [
      "🟠 You didn't find the correct answer, but let's try again.",
      "🟠 Wrong answer. You can try again.",
      "🟠 Wrong answer... Don't give up and try again.",
      "🟠 You didn't get it right but you still can modify your answer.",
      "🟠 That is not the right answer... Try again.",
    ],
    kids: [
      "🟠 You didn't find the correct answer, but let's try again !",
      "🟠 Wrong answer, too bad ! Take a deep breath and focus, you will get it right !",
      "🟠 Wrong answer... Go go go ! Don't give up !",
      "🟠 You didn't get it right but you still can modify your answer.",
      "🟠 Wrong answer, crap ! You can get it right if you correct your answer !",
      "🟠 That is not the right answer... Your next try will be the good one !",
      "🟠 Arg, wrong answer ! Don't give up !",
    ],
    formal: [
      "🟠 You didn't find the correct answer, but let's try again.",
      "🟠 Wrong answer. You can try again.",
      "🟠 Wrong answer... Don't give up and try again.",
      "🟠 You didn't get it right but you still can modify your answer.",
      "🟠 That is not the right answer... Try again.",
    ],
  },

  defaultMessageSolution: "The solution is ",

  defaultMessageMCQSolutionAnswer: "is the solution",
  defaultMessageReorderSolutionFound: "All the elements are well ordered",
  defaultMessageReorderSolutionNotFound: "Some elements are in the wrong place",
  defaultMessageAssociateSolutionFound: "All the elements are well associated",
  defaultMessageAssociateSolutionNotFound:
    "Some elements are wrongly associated",
  questionOpenExpressionDeprecatedMode:
    "How to write a mathematical expression?",
  questionOpenExpressionDeprecatedModeMathSymbols: `
    Use <b>*</b> for multiply. eg: a*b means a × b <br/>
    Use <b>/</b> for fractions. eg: 1/4 means ¼ <br/>
    Use <b>^</b> for power. eg: a^2 means a² <br/>
    Use <b>sqrt()</b> for square root. eg: sqrt(a) means √a
    `,

  //ERRORS used by manageErrors
  emptyMultipleChoiceQuestion:
    "Error in activity design: There is no choice in this question",
  emptyQuestionReorder:
    "Error in activity design: There is no elements to reorder",
  notAFractionQuestionFraction:
    "Error in activity design: Correct answer (fraction) seems to not be a fraction",
  emptyQuestionAssociate:
    "Error in activity design: There is no elements to associate",
  emptyQuestionOpen:
    "Error in activity design: There is no solution in this question",
  notElementBoardQuestionFigure:
    "Error in activity design: There is no graphic board in this question",
  notAExpressionQuestionExpression:
    "Error in activity design: Correct answer (expression) seems to not be a expression",
};
